import QuestionIcon from '@/app/icons/QuestionIcon';
import CopyIcon from '@/app/icons/CopyIcon';
import { copyToClipboard } from '@/app/utils/stringUtils';
import React from 'react';

interface IProps {
  text: string;
  helpText?: string;
  copyText?: string;
}

export default function AccountItem(props: IProps) {
  return (
    <div className="flex gap-2 align-middle">
      <div>{props.text}</div>
      {props.copyText && (
        <div
          onClick={() => copyToClipboard(props.copyText)}
          className="tooltip scale-90 cursor-pointer"
          data-tip={'Copy to clipboard.'}
        >
          <CopyIcon />
        </div>
      )}
      {props.helpText && (
        <div className="tooltip scale-90" data-tip={props.helpText}>
          <QuestionIcon />
        </div>
      )}
    </div>
  );
}
